import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appQueriesStore } from "@/app/api";
import {
  billingQueriesStore,
  createPatientSubscriptions,
} from "@/features/billing/api";
import { productsQueriesStore } from "@/features/products/api";
import { referralQueriesStore } from "@/features/referral/api";
import { errorToast } from "@/shared/ui";

export const useCreatePatientSubscriptions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createPatientSubscriptions,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: appQueriesStore.user.queryKey,
      });

      void queryClient.invalidateQueries({
        queryKey: billingQueriesStore.subscriptions.queryKey,
      });

      void queryClient.invalidateQueries({
        queryKey: productsQueriesStore.products.shop.queryKey,
      });

      void queryClient.invalidateQueries({
        queryKey: referralQueriesStore.credit.queryKey,
      });
    },
    onError: errorToast,
  });
};
